import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

interface TreatmentHeroProps {
  title: string
  subtitle?: string
  image?: string
  imageAlt?: string
  className?: string
}

export function TreatmentHero({
  title,
  subtitle,
  image,
  imageAlt,
  className,
}: TreatmentHeroProps) {
  return (
    <section
      className={cn(
        'relative bg-ink-deep pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden',
        className
      )}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold italic text-white leading-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-4 text-lg md:text-xl text-white/80 max-w-xl">
                {subtitle}
              </p>
            )}
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            {image ? (
              <div className="aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src={image}
                  alt={imageAlt || title}
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div className="aspect-[4/3] rounded-xl bg-primary/10 flex items-center justify-center">
                <span className="font-display text-8xl font-semibold italic text-primary/20">
                  {title.charAt(0)}
                </span>
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  )
}
